<div class="column">
	<div class="row">
		<div class="flex-row-space-between">
			<span class="content-header" i18n="@@deviceControlDetailsCommon-assignTimeHeader"> Access Time </span>
		</div>

		<mat-checkbox
			class="padding-left-smaller checkbox-text-size all-day-access-checkbox"
			[disabled]="is247CheckboxDisabled()"
			[ngModel]="
				(edits.days.sunday.value &&
					edits.days.monday.value &&
					edits.days.tuesday.value &&
					edits.days.wednesday.value &&
					edits.days.thursday.value &&
					edits.days.friday.value &&
					edits.days.saturday.value &&
					edits.startTime === '00:00:00' &&
					edits.endTime === '24:00:00' &&
					edits.id !== '') ||
				(edits.id === '' && allDayAccessCheckboxSelection)
			"
			(change)="onAllDayAccessClicked($event)"
			i18n="@@deviceControllerDetails-247access"
			data-automation-id="twenty-four-seven-access-checkbox"
		>
			24/7 access
		</mat-checkbox>
	</div>

	<div [ngClass]="{ 'view-only-opacity': isViewOnly }">
		<div class="drawer-dialog-content-input-container">
			<div class="flex-row-space-between">
				<div class="mat-body-2 weekly-reoccurrence-header" i18n="@@deviceControlDetailsCommon-weeklyReoccurence">
					Weekly Recurrence
					<span class="asterisk-text" data-automation-id="deviceControlDetailsCommon-weeklyRecurrence-required">*</span>
				</div>
			</div>
			<div class="reoccurrence-day-of-week-toggle-container">
				<span>
					<app-day-of-week-toggle
						label="Su"
						i18n-label="Letter representing sunday@@deviceControlDetailsCommon-sunday"
						[selection]="edits.days.sunday.value ?? false"
						(selectionChange)="onDayOfWeekToggled('sunday', $event)"
						[disabled]="edits.days.sunday.disabled ?? false"
					></app-day-of-week-toggle>
					<app-day-of-week-toggle
						label="Mo"
						i18n-label="Letter representing monday@@deviceControlDetailsCommon-monday"
						[selection]="edits.days.monday.value ?? false"
						(selectionChange)="onDayOfWeekToggled('monday', $event)"
						[disabled]="edits.days.monday.disabled ?? false"
					></app-day-of-week-toggle>
					<app-day-of-week-toggle
						label="Tu"
						i18n-label="Letter representing tuesday@@deviceControlDetailsCommon-tuesday"
						[selection]="edits.days.tuesday.value ?? false"
						(selectionChange)="onDayOfWeekToggled('tuesday', $event)"
						[disabled]="edits.days.tuesday.disabled ?? false"
					></app-day-of-week-toggle>
				</span>
				<span>
					<app-day-of-week-toggle
						label="We"
						i18n-label="Letter representing wednesday@@deviceControlDetailsCommon-wednesday"
						[selection]="edits.days.wednesday.value ?? false"
						(selectionChange)="onDayOfWeekToggled('wednesday', $event)"
						[disabled]="edits.days.wednesday.disabled ?? false"
					></app-day-of-week-toggle>
					<app-day-of-week-toggle
						label="Th"
						i18n-label="Letter representing thursday@@deviceControlDetailsCommon-thursday"
						[selection]="edits.days.thursday.value ?? false"
						(selectionChange)="onDayOfWeekToggled('thursday', $event)"
						[disabled]="edits.days.thursday.disabled ?? false"
					></app-day-of-week-toggle>
				</span>
				<span>
					<app-day-of-week-toggle
						label="Fr"
						i18n-label="Letter representing fridday@@deviceControlDetailsCommon-friday"
						[selection]="edits.days.friday.value ?? false"
						(selectionChange)="onDayOfWeekToggled('friday', $event)"
						[disabled]="edits.days.friday.disabled ?? false"
					></app-day-of-week-toggle>
					<app-day-of-week-toggle
						label="Sa"
						i18n-label="Letter representing saturday@@deviceControlDetailsCommon-saturday"
						[selection]="edits.days.saturday.value ?? false"
						(selectionChange)="onDayOfWeekToggled('saturday', $event)"
						[disabled]="edits.days.saturday.disabled ?? false"
					></app-day-of-week-toggle>
				</span>
			</div>
		</div>

		<div class="row content-sub-title" i18n="@@deviceControlDetailsCommon-timezoneBasedOnLocation">
			Time zone based on device location
		</div>

		@if (!edits.isOwner) {
			<div class="reoccurrence-toggle-container">
				<div class="drawer-dialog-detail-content-input-container">
					<div class="flex-row-space-between">
						<div class="mat-body-2" i18n="@@deviceControlDetailsCommon-startTimeHeader">
							Start Time
							<span class="asterisk-text" data-automation-id="deviceControlDetailsCommon-startTimeInput-required"
								>*</span
							>
						</div>
					</div>
					<app-military-time-picker
						data-automation-id="device-control-one-military-time-picker"
						[passedInTime]="edits.startTime"
						[disabled]="isViewOnly"
						[endTimeMustBeAfter]="minStartTime"
						[endTimeMustBeBefore]="getEffectiveMaxTime()"
						(onTimeSelected)="onStartTimeSelected($event)"
						class="select-border"
					></app-military-time-picker>
				</div>
				<div class="drawer-dialog-detail-content-input-container">
					<div class="flex-row-space-between">
						<div class="mat-body-2" i18n="@@deviceControlDetailsCommon-endTimeHeader">
							End Time
							<span class="asterisk-text" data-automation-id="deviceControlDetailsCommon-endTimeInput-required">*</span>
						</div>
					</div>
					<app-military-time-picker
						data-automation-id="device-control-two-military-time-picker"
						[passedInTime]="edits.endTime"
						[disabled]="isViewOnly"
						[endTimeMustBeAfter]="getEffectiveMinTime()"
						[endTimeMustBeBefore]="maxEndTime"
						(onTimeSelected)="onEndTimeSelected($event)"
						class="select-border"
					></app-military-time-picker>
				</div>
			</div>
		}

		@if (edits.isOwner) {
			<div class="reoccurrence-toggle-container">
				<div class="drawer-dialog-detail-content-input-container">
					<div class="flex-row-space-between">
						<div class="mat-body-2" i18n="@@deviceControlDetailsCommon-startTimeHeader">
							Start Time
							<span class="asterisk-text" data-automation-id="deviceControlDetailsCommon-startTimeInput-required"
								>*</span
							>
						</div>
					</div>
					<app-military-time-picker
						data-automation-id="device-control-three-military-time-picker"
						[passedInTime]="edits.startTime"
						[disabled]="isViewOnly"
						(onTimeSelected)="onStartTimeSelected($event)"
						class="select-border"
					></app-military-time-picker>
				</div>
				<div class="drawer-dialog-detail-content-input-container">
					<div class="flex-row-space-between">
						<div class="mat-body-2" i18n="@@deviceControlDetailsCommon-endTimeHeader">
							End Time
							<span class="asterisk-text" data-automation-id="deviceControlDetailsCommon-endTimeInput-required">*</span>
						</div>
					</div>
					<app-military-time-picker
						data-automation-id="device-control-four-military-time-picker"
						[passedInTime]="edits.endTime"
						[disabled]="isViewOnly"
						[endTimeMustBeAfter]="getEffectiveMinTime()"
						(onTimeSelected)="onEndTimeSelected($event)"
						class="select-border"
					></app-military-time-picker>
				</div>
			</div>
		}
	</div>

	@if (showDeviceCapabilitiesSection) {
		<div>
			<mat-divider class="mat-divider-spacing"></mat-divider>
			<div class="flex-row-space-between">
				<span class="content-header" i18n="@@deviceControlDetailsCommon-chooseDeviceCapablitiesHeader">
					Device Capabilities
				</span>
				@if (showStandardDeviceCapabilities) {
					<span class="asterisk-text">*</span>
				}
			</div>
		</div>
	}

	@if (showStandardDeviceCapabilities) {
		<div
			id="device-capability-divider"
			class="padding-top-small multi-checkbox-container"
			[ngClass]="{ 'view-only-opacity': isViewOnly }"
		>
			<div class="row row-padding checkbox-group">
				<mat-checkbox
					data-automation-id="device-access-checkbox"
					class="checkbox-text-size"
					[disabled]="isDeviceAccessDisabled"
					[checked]="isDeviceAccessChecked"
					(change)="onDeviceAccessToggled(!isDeviceAccessChecked)"
				>
					<mat-icon svgIcon="sl-open-key-door" style="height: 1rem"></mat-icon>
					<ng-container i18n="@@deviceControlDetailsCommon-deviceAccessControlName">Device Access</ng-container>
				</mat-checkbox>
			</div>
			<div class="row row-padding checkbox-group">
				<mat-checkbox
					data-automation-id="install-device-checkbox"
					class="checkbox-text-size"
					[disabled]="edits.permissions.canInstallDevice.disabled"
					[checked]="edits.permissions.canInstallDevice.value"
					(change)="onDeviceCapabilitiesToggled('canInstallDevice', !edits.permissions.canInstallDevice.value)"
				>
					<mat-icon svgIcon="sl-install-device" style="height: 1rem"></mat-icon>
					<ng-container i18n="@@deviceControlDetailsCommon-installControlName">Install Device</ng-container>
				</mat-checkbox>
			</div>
			<div class="row row-padding checkbox-group">
				<mat-checkbox
					data-automation-id="remove-device-checkbox"
					class="checkbox-text-size"
					[disabled]="edits.permissions.canRemoveDevice.disabled"
					[checked]="edits.permissions.canRemoveDevice.value"
					(change)="onDeviceCapabilitiesToggled('canRemoveDevice', !edits.permissions.canRemoveDevice.value)"
				>
					<mat-icon svgIcon="sl-remove-device" style="height: 1rem"></mat-icon>
					<ng-container i18n="@@deviceControlDetailsCommon-removeDeviceControlName">Remove Device</ng-container>
				</mat-checkbox>
			</div>
			@if (isHaspCodeGenFeatureEnabled && assignmentType === 'company') {
				<div class="row row-padding checkbox-group">
					<mat-checkbox
						data-automation-id="allow-code-generation-checkbox"
						class="checkbox-text-size"
						[disabled]="deviceAssignmentEdits.allowCodeGeneration.disabled"
						[checked]="deviceAssignmentEdits.allowCodeGeneration.value"
						(change)="
							onDeviceAssignmentsToggled('allowCodeGeneration', !deviceAssignmentEdits.allowCodeGeneration.value)
						"
					>
						<mat-icon svgIcon="sl-generate-access-code" style="height: 1rem"></mat-icon>
						<ng-container i18n="@@deviceControlDetailsCommon-generateAccessCodeControlName"
							>Generate Access Code</ng-container
						>
					</mat-checkbox>
				</div>
				@if (showGenerateHaspCodeCapability) {
					<div class="row row-padding checkbox-group">
						<mat-checkbox
							data-automation-id="generate-hasp-code-checkbox"
							class="checkbox-text-size"
							[disabled]="deviceAssignmentEdits.allowHaspCodeGeneration.disabled"
							[checked]="deviceAssignmentEdits.allowHaspCodeGeneration.value"
							(change)="
								onDeviceAssignmentsToggled(
									'allowHaspCodeGeneration',
									!deviceAssignmentEdits.allowHaspCodeGeneration.value
								)
							"
						>
							<mat-icon svgIcon="sl-generate-hasp-code" style="height: 1rem"></mat-icon>
							<ng-container i18n="@@deviceControlDetailsCommon-generateHaspCodeControlName"
								>Generate Hasp Code</ng-container
							>
							<mat-icon
								class="tooltip-icon mobile-tooltip-icon"
								svgIcon="sl-info-square"
								[matTooltip]="wallMountTooltip"
								matTooltipClass="mobile-tooltip"
								(click)="$event.stopPropagation()"
								(touchend)="$event.stopPropagation()"
								[attr.aria-label]="wallMountTooltip"
								role="button"
								tabindex="0"
							>
							</mat-icon>
						</mat-checkbox>
					</div>
				}
			}
		</div>
	}

	<!--
      AJAX Device Capabilities
      Can only be seen by device groups with at least one ajax device OR devices with AJAX functionality.
      In addition, they should have access to see the AJAX device capabilities.
      -->
	@if (showAjaxDeviceCapabilities) {
		<div class="column-double multi-checkbox-container" [ngClass]="{ ' padding-top-small': isSpecialGrantAccessMode }">
			<div class="row row-padding checkbox-group">
				<mat-checkbox
					data-automation-id="arm-disarm-alarm-checkbox"
					class="checkbox-text-size"
					[disabled]="isArmDisarmUiDisabled"
					[checked]="edits.permissions.canArmDisarmAjaxAlarm.value"
					(change)="
						onDeviceCapabilitiesToggled('canArmDisarmAjaxAlarm', !edits.permissions.canArmDisarmAjaxAlarm.value)
					"
				>
					<div class="alarm-checkbox-container">
						<mat-icon svgIcon="sl-shield-checkmark" style="height: 1rem"></mat-icon>
						<ng-container i18n="@@deviceControlDetailsCommon-armDismarmAlarmControlName">Arm/Disarm Alarm</ng-container>
					</div>
				</mat-checkbox>
			</div>
			<div class="row row-padding checkbox-group">
				<mat-checkbox
					data-automation-id="alarm-override-checkbox"
					class="checkbox-text-size"
					[disabled]="isAlarmOverrideUiDisabled"
					[checked]="edits.permissions.canOverrideAjaxAlarm.value"
					(change)="onDeviceCapabilitiesToggled('canOverrideAjaxAlarm', !edits.permissions.canOverrideAjaxAlarm.value)"
				>
					<div class="alarm-checkbox-container">
						<mat-icon svgIcon="sl-bell-crossed-out" style="height: 1rem"></mat-icon>
						<ng-container i18n="@@deviceControlDetailsCommon-alarmOverrideControlName">Alarm Override</ng-container>
					</div>
				</mat-checkbox>
			</div>
		</div>
	}

	<!--
      US14633: for PDQ devices or device groups ONLY containing PDQ devices, we hide all most other device capabilities
      relating to lock sets and handle setting all other device capability functionality on the back end.
      Currently, we enable all other device capabilities by default, with the exception of generating access codes, by default.
      -->
	@if (showSpecialCompanyCapabilitySection) {
		<div
			class="column-double multi-checkbox-container"
			[ngClass]="{
				'view-only-opacity': isViewOnly,
				'padding-top-small': !(hasAtLeastOneAJAXDevice && !edits.permissions.canArmDisarmAjaxAlarm.disabled),
			}"
		>
			<div class="row checkbox-group">
				<mat-checkbox
					data-automation-id="allow-code-generation-checkbox"
					class="checkbox-text-size single-generate-access-code-checkbox-in-row"
					[disabled]="deviceAssignmentEdits.allowCodeGeneration.disabled"
					[checked]="deviceAssignmentEdits.allowCodeGeneration.value"
					(change)="onDeviceAssignmentsToggled('allowCodeGeneration', !deviceAssignmentEdits.allowCodeGeneration.value)"
				>
					<mat-icon svgIcon="sl-generate-access-code" style="height: 1rem"></mat-icon>
					<ng-container i18n="@@deviceControlDetailsCommon-generateAccessCodeControlName2">
						Generate Access Code
					</ng-container>
				</mat-checkbox>
			</div>
		</div>
	}

	<mat-divider
		class="mat-divider-spacing"
		[class]="{ 'spacing-top-none': showDeviceCapabilitiesSection }"
	></mat-divider>

	<!-- Currently not in use -->
	@if (showImpactWarning && isEdit) {
		<app-infobox
			displayType="warning"
			header="Warning"
			body="Changes to this control will affect <strong>{{
				this.control.assignedEntityCount
			}}</strong> downstream assignees and <strong>{{ this.control.assignedDeviceGroupCount }}</strong> device groups."
			style="padding: 3em 10%"
		>
		</app-infobox>
	}
</div>
